var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSchoolAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_ionic-ios-people",
    "data-name": "Icon ionic-ios-people",
    xmlns: "http://www.w3.org/2000/svg",
    width: 61.35,
    height: 39.871,
    viewBox: "0 0 61.35 39.871",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_94247",
    "data-name": "Path 94247",
    d: "M39.973,38.423c-1.53-.547-4.031-.574-5.138-1a7.258,7.258,0,0,1-2.377-1.107c-.4-.478-.4-3.894-.4-3.894a6.291,6.291,0,0,0,1.353-1.913,21.26,21.26,0,0,0,.656-3.758s.9.383,1.257-1.421c.3-1.558.874-2.377.724-3.525s-.792-.874-.792-.874.792-1.161.792-5.11c0-4.072-3.074-8.075-8.827-8.075s-8.84,4.017-8.84,8.075c0,3.949.779,5.11.779,5.11s-.642-.273-.792.874.41,1.968.724,3.525c.355,1.817,1.257,1.421,1.257,1.421a21.465,21.465,0,0,0,.656,3.758,6.291,6.291,0,0,0,1.353,1.913s0,3.416-.4,3.894a6.986,6.986,0,0,1-2.377,1.093c-1.093.424-3.594.478-5.138,1.025a9.643,9.643,0,0,0-6.258,9.182H46.218A9.624,9.624,0,0,0,39.973,38.423Z",
    transform: "translate(3.423 -7.748)",
    fill: "#afb0ff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_94248",
    "data-name": "Path 94248",
    d: "M17.04,28.506s3.266-.109,4.564-1.271c-2.118-3.211-.97-6.955-1.407-10.453s-2.418-5.575-6.381-5.575h-.055c-3.826,0-5.889,2.077-6.326,5.575s.779,7.652-1.394,10.453c1.3,1.175,4.577,1.134,4.577,1.134h0a6.92,6.92,0,0,1-.137,2.3,3.45,3.45,0,0,1-1.64.752A31.7,31.7,0,0,0,5.3,32.4a5.753,5.753,0,0,0-3.088,5.083H13.187c.3-1.093,2.364-3.047,4.372-4.072a9.175,9.175,0,0,1,3.375-.711s.519-.82-1.189-1.134a11.647,11.647,0,0,1-2.623-.915C16.862,30.351,17.04,28.506,17.04,28.506Z",
    transform: "translate(-2.215 -4.485)",
    fill: "#afb0ff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_94249",
    "data-name": "Path 94249",
    d: "M28.372,28.506s-3.266-.109-4.564-1.271c2.118-3.211.97-6.955,1.407-10.453s2.418-5.575,6.381-5.575h.055c3.826,0,5.889,2.077,6.326,5.575s-.779,7.652,1.394,10.453c-1.3,1.175-4.577,1.134-4.577,1.134h0a6.92,6.92,0,0,0,.137,2.3,3.45,3.45,0,0,0,1.64.752,31.7,31.7,0,0,1,3.539.984A5.753,5.753,0,0,1,43.2,37.483H32.225c-.3-1.093-2.364-3.047-4.372-4.072a9.175,9.175,0,0,0-3.375-.711s-.519-.82,1.189-1.134a11.647,11.647,0,0,0,2.623-.915C28.549,30.351,28.372,28.506,28.372,28.506Z",
    transform: "translate(18.154 -4.485)",
    fill: "#afb0ff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchoolAdmin);
export default __webpack_public_path__ + "static/media/SchoolAdmin.ddf43c6c567aff8e463dcf02f10add83.svg";
export { ForwardRef as ReactComponent };